import { migrationUtils, favoritesStorage, MAX_FAVORITES } from './storage';
import { toast } from 'react-toastify';
import React, { useState, useRef } from 'react';
import './FavoritesManager.css';

const FavoritesManager = ({ onUpdate }) => {
  const [isImporting, setIsImporting] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const fileInputRef = useRef(null);
  
  const currentCount = favoritesStorage.getAll().length;
  
  const handleExport = () => {
    if (currentCount === 0) {
      toast.info('You have no favorites to export', {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    migrationUtils.exportFavorites();
    
    toast.success(`Exported ${currentCount} favorites to file`, {
      position: "top-right",
      autoClose: 3000,
    });
  };
  
  const handleImportClick = () => {
    fileInputRef.current.click();
  };
  
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setIsImporting(true);
    
    try {
      const result = await migrationUtils.importFavorites(file);
      console.log("Import result:", result);
      
      if (result && result.reachedLimit) {
        setTimeout(() => {
          toast.warning(`Maximum limit of ${MAX_FAVORITES} favorites reached. Some items were not imported.`, {
            position: "top-right",
            autoClose: 5000,
          });
        }, 100);
      }
      
      setTimeout(() => {
        toast.success(`Successfully imported ${result && result.added ? result.added : 0} favorites`, {
          position: "top-right",
          autoClose: 3000,
        });
      }, 200);
      
      // Notify parent component that favorites have been updated
      if (onUpdate) onUpdate();
      
    } catch (error) {
      console.error("Import error:", error);
      setTimeout(() => {
        toast.error(`Import failed: ${error.message}`, {
          position: "top-right",
          autoClose: 5000,
        });
      }, 100);
    } finally {
      setIsImporting(false);
      // Reset file input
      e.target.value = null;
    }
  };
  
  return (
    <div className="favorites-manager">
      {/* COMPACT HEADER - Always visible */}
      <div className="favorites-header" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="favorites-count-display">
          <span className="count-badge">{currentCount}/{MAX_FAVORITES}</span>
          <span className="count-label">Favorites</span>
        </div>
        <div className="expand-toggle">
          <span className={`expand-arrow ${isExpanded ? 'expanded' : ''}`}>▼</span>
          <span className="expand-label">Manage</span>
        </div>
      </div>
      
      {/* EXPANDABLE CONTENT - Hidden by default */}
      {isExpanded && (
        <div className="favorites-content">
          <div className="favorites-manager-buttons">
            <button 
              className="favorites-button export-button" 
              onClick={handleExport}
              disabled={isImporting}
            >
              <span className="button-icon">📤</span>
              Export Favorites
            </button>
            
            <button 
              className="favorites-button import-button" 
              onClick={handleImportClick}
              disabled={isImporting}
            >
              <span className="button-icon">📥</span>
              {isImporting ? 'Importing...' : 'Import Favorites'}
            </button>
            
            <input 
              type="file" 
              ref={fileInputRef} 
              style={{ display: 'none' }} 
              accept=".json"
              onChange={handleFileChange}
            />
          </div>
          
          <div className="favorites-info">
            <p>
              Favorites are stored in your browser's local storage. 
              Export them to keep a backup or transfer to another browser.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FavoritesManager;